!function(angular){
    "use strict";

    var settings = angular.module("tablet.settings", []);

    settings.constant("appSettings", {
        apiBaseUri: "/gf-servicemanager-api",
        apiAuthenticationUri: "/gf-servicemanager-api/oauth/token",
        appBaseUri: '/gf-servicemanager-tablet',
        engineerRole: 'ENGINEER',
        clientId: 'CCD8F307-565A-440E-AA2D-B45819055817',
        srListRefreshIntervalMillisForSee: 86400000,
        srListRefreshIntervalMillis: 300000,
        srListRefreshIntervalMillisForEngineer: 300000,
        storeApproverRole:"STORE_APPROVER",
        storeManagerRole:"STORE_MANAGER",
        costApproverRole:"COST_APPROVER",
        storeLoginType: "STORE",
        engineerLoginType: "ENGINEER",
        hkAdminRole:"HK_ADMIN",
        impersonationLoginType: "IMPERSONATE"
    });

    settings.constant("storageKeys", {
        savedPathKey: 'SAVED_PATH_BEFORE_REDIRECT',
        profileKey: "PROFILE_DATA",
        storeKey: "STORE_DATA",
        loginTypeKey: "LOGIN_TYPE",
        storeContextKey: "STORE_CONTEXT",
        appVersion: "APP_VERSION",
        sseKey:"SSE_KEY",
        impersonatedKey:"USER_IMPERSONATED",
        etechTasksStoreRedirectUriKey:"ETECH_TASKS_STORE_REDIRECT_URI",
        appDateTimeFormat: "APP_DATETIME_FORMAT",
        appDateFormat: "APP_DATE_FORMAT"
    });
}(angular)